import { Spinner } from "@resamare/ui";
import { useGetConfig } from "@resamare/widgets-shared";
import { Navigate } from "react-router-dom";

export function DefaultRoute() {
    const configQuery = useGetConfig();

    if (configQuery.isPending) return <Spinner />;
    if (!configQuery.data) return null;

    if (configQuery.data.mode_scan === "global") {
        return <Navigate to="/scan" />;
    }

    return <Navigate to="/sessions" />;
}
